module.exports = __webpack_public_path__ + "img/h.587370a3.jpg";